<script setup lang="ts">
const props = defineProps<{ placeLink: string, placeTx: string, settleLink?: string, settleTx?: string, positionIndex: number }>();
</script>

<template>
  <div class="history-item-container">
    <div class="history-item-right">
      <div v-if="props.placeTx.startsWith('0x')" :id="'history-item-' + props.positionIndex + '-place'" class="history-item-place">Place: <a :href="props.placeLink" target="new">{{ props.placeTx }}</a></div>
      <div :id="'history-item-' + props.positionIndex + '-settle'" class="history-item-settle">Settle: <a v-if="props.settleLink && props.settleTx" :href="props.settleLink" target="new">{{ props.settleTx }}</a></div>
    </div>
  </div>
</template>

<style scoped>
.history-item-container {
  display: flex;
}

.history-item-right {
  display: inline;
}

.history-item-place {
  display: block;
  font-family: WorkSans;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1f1f1f;
}

.history-item-settle {
  display: block;
  font-family: WorkSans;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1f1f1f;
}
</style>